export const PARTNER_CHAT_ROUTE_PATHS = {
  partnerConversations: '/panel/conversations',
  partnerConversation: '/panel/conversations/$externalId',
} as const;
